import a from "./td-longtail-vue-components107.js";
/* empty css                              */
import n from "./td-longtail-vue-components98.js";
var o = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("img", { class: e.imageClass, style: e.imageStyle, attrs: { src: r.defaultImage.src, alt: e.alt || "", loading: e.lazy ? "lazy" : void 0, srcset: r.defaultImage.srcset, sizes: r.defaultImage.sizes }, on: { error: function(s) {
    return e.$emit("image-error", s);
  } } });
}, l = [], m = /* @__PURE__ */ n(
  a,
  o,
  l,
  !1,
  null,
  "024a45e1"
);
const u = m.exports;
export {
  u as default
};
